import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-privacy-policy',
  templateUrl: './edit-privacy-policy.component.html',
  styleUrls: ['./edit-privacy-policy.component.css']
})
export class EditPrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
